<script setup lang="ts">
import ProgressFrame from './layout/ProgressFrame.vue';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import ButtonOutlined from '@/shared/components/button/ButtonOutlined.vue';
import { useCommissioningDeviceStore } from '../stores/commissioningDeviceStore';
import router from '@/router';

const deviceStore = useCommissioningDeviceStore();
const serialNumber = deviceStore.serialNumber;

const recommission = () => {
  if (typeof deviceStore.userHasAccess === 'boolean') {
    if (deviceStore.userHasAccess) {
      deviceStore.resetRecommissionPrepare();
      router.replace({ name: 'SearchingSolshareRecommissionSetup' });
    } else {
      router.replace({ name: 'SearchingSolshareRecommissionContactSupport' });
    }
  } else {
    router.replace({ name: 'SerialNumberHow' });
  }
};

const commissionAnother = () => {
  router.replace({ name: 'SerialNumberHow' });
};
</script>

<template>
  <ProgressFrame pageClass="subsection-page" :titleTight="true" >
    <template #title> This SolShare has already been commissioned. </template>
    <template #subTitle> {{ serialNumber }} </template>

    <div class="content">
      <p class="message">This SolShare has already been set up. Recommission it to update its configuration, or commission a different SolShare.</p>
      <div class="button-container">
        <ButtonPrimary block @click="recommission" data-tn="recommission-btn">
          Recommission this SolShare
        </ButtonPrimary>
        <ButtonOutlined block @click="commissionAnother" data-tn="commission-another-btn">
          Commission another SolShare
        </ButtonOutlined>
      </div>
    </div>
  </ProgressFrame>
</template>

<style lang="less" scoped>
.message {
  text-align: center;
}

.button-container {
  width: 100%;
  margin-top: @margin-top-end-of-page-section;
  margin-bottom: 0;
  margin-left: @content-side-margin;
  margin-right: @content-side-margin;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
